import { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { Image } from '@imagekit/react'
import useStyles from '../styles/useStyles'
import { ASSETS } from '../config/imagekit'

type Props = {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}

const AuthLayout = ({ title, subtitle, children, footer }: Props) => {
  const classes = useStyles()
  return (
    <Box className={classes.loginShell}>
      <Box className={classes.loginVisual}>
        <Image
          src={ASSETS.supportBackground}
          alt=""
          className={classes.loginVisualImage}
          loading="eager"
        />
        <Box className={classes.loginVisualOverlay} />

        <Box className={classes.loginVisualBrand}>
          <Image
            src={ASSETS.logoVoxist}
            alt=""
            width={22}
            height={22}
            responsive={false}
          />
          <span>Voxist · Support</span>
        </Box>

        <Box className={classes.loginVisualCopy}>
          <Box className={classes.loginVisualHeadline}>
            Care, at the speed of a click.
          </Box>
          <Box className={classes.loginVisualTagline}>
            The internal toolbox for the team that keeps Voxist users heard.
          </Box>
        </Box>

        <Box className={classes.loginVisualFootnote}>
          Internal use only · Voxist Support
        </Box>
      </Box>

      <Box className={classes.loginPanel}>
        <Box className={classes.loginCard}>
          <Box className={classes.loginLogoRow}>
            <Image
              src={ASSETS.logoVoxist}
              alt="Voxist"
              width={40}
              height={40}
              responsive={false}
            />
          </Box>

          <Box className={classes.loginTitle}>{title}</Box>
          {subtitle && (
            <Box className={classes.loginSubtitle}>{subtitle}</Box>
          )}

          {children}

          <Box className={classes.loginFooter}>
            {footer ?? (
              <>© {new Date().getFullYear()} Voxist · All rights reserved</>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AuthLayout
